import React from "react";
import { useRoutes } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";
import PublicDashboard from "./pages/PublicDashboard";
import Login from "./pages/Login";
import BasicRole from "./pages/BasicRole";
import EmployeeRegister from "./pages/EmployeeRegister";
import CollegeTeacherRegistration from "./pages/CollegeTeacherRegistration";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import SwitchRole from "./pages/SwitchRole";
import GuesthousePendingBookings from "./pages/GuesthousePendingBookings";
import GuesthouseRoomLogbook from "./pages/GuesthouseRoomLogbook";
import GuesthouseCheckInCheckOut from "./pages/GuesthouseCheckInCheckOut";
import GuesthouseTariff from "./pages/GuesthouseTariff";
import Logout from "./pages/Logout";
import DepartmentsCentres from "./pages/DepartmentsCentres";
import Directory from "./pages/Directory";
import HolidayList from "./pages/HolidayList";
import Rooms from "./pages/Rooms";
import ChangePassword from "./pages/ChangePassword";
import GuesthouseBooking from "./pages/GuesthouseBooking";
import GuesthouseBookingRequestAdmin from "./pages/GuesthouseBookingRequestAdmin";
import GuesthouseBookingRequestByMobile from "./pages/GuesthouseBookingRequestByMobile";
import GuesthouseChangeRequest from "./pages/GuesthouseChangeRequest";
import GuesthouseBookingStatus from "./pages/GuesthouseBookingStatus";
import GuesthouseBookingEditRequest from "./pages/GuesthouseBookingEditRequest";
import LeaveDetails from "./pages/LeaveDetails";
import NewEmpLeave from "./pages/NewEmpLeave";
import LeaveStatus from "./pages/LeaveStatus";
import GuesthouseContent from "./pages/GuesthouseContent/GuesthouseContent";
import MasterModule from './pages/MasterModule';
import EmployeeListMaster from "./pages/EmployeeListMaster";
import EmployeeEdit from "./pages/EmployeeEdit";
import SeniorityList from "./pages/SeniorityList";
import SeniorityListOffice from "./pages/SeniorityListOffice";
import DepartmentRecord from "./pages/DepartmentRecord";
import FellowsList from "./pages/FellowsList";
import CollegeTeachersList from "./pages/CollegeTeachersList";
import DeputyRegistrarColleges from "./pages/DeputyRegistrarColleges";
import DrCollegeList from "./pages/DrCollegeList";
import DrPendingPrincipals from "./pages/DrPendingPrincipals";
import ComplaintStatus from "./pages/ComplaintStatus";
import NewResidentialComplaint from "./pages/NewResidentialComplaint";
import OfficialComplaintStatus from "./pages/OfficialComplaintStatus";
import NewDepartmentComplaint from "./pages/NewDepartmentComplaint";
import ForgotPassword from "./pages/ForgotPassword";
import EmployeeInstructions from "./pages/EmployeeInstructions";
import PendingVerifications from "./pages/PendingVerifications";
import PendingVerificationsTeachers from "./pages/PendingVerificationsTeachers";
import PendingVerificationsMembers from "./pages/PendingVerificationsMembers";
import SanctionedPosts from "./pages/SanctionedPosts";
import LeaveDetailsOffice from "./pages/LeaveDetailsOffice";
import PendingLeaveOffice from "./pages/PendingLeaveOffice";
import NewLeaveByOffice from "./pages/NewLeaveByOffice";
import AchievementsOffice from "./pages/AchievementsOffice";
import NewAchievementOffice from "./pages/NewAchievementOffice";
import MyAchievements from "./pages/MyAchievements";
import StudentAttendance from "./pages/StudentAttendance";
import StudentsList from "./pages/StudentsList";
import StudentLeave from "./pages/StudentLeave";
import NewStudentLeave from "./pages/NewStudentLeave";
import StudentIndLeave from "./pages/StudentIndLeave";
import StudentIndAtt from "./pages/StudentIndAtt";
import StudentMonthlyAttRaw from "./pages/StudentMonthlyAttRaw";
import StudentMonthlyAttLeave from "./pages/StudentMonthlyAttLeave";
import StudentUploadAtt from "./pages/StudentUploadAtt";
import StudentVerifiedList from "./pages/StudentVerifiedList";
import ResolverComplaintList from "./pages/ResolverComplaintList";
import ResolverAction from "./pages/ResolverAction";
import ResolverPending from "./pages/ResolverPending";
import NewMember from "./pages/NewMember";
import DentalAtt from "./pages/DentalAtt";
import AdminAtt from "./pages/AdminAtt";
import CdoeAtt from "./pages/CdoeAtt";
import Attendance from "./pages/Attendance";
import ShiftEmployee from "./pages/ShiftEmployee";
import SpecialRoles from "./pages/SpecialRoles";
import DepartmentalRoles from "./pages/DepartmentalRoles";
import MarkAttendance from "./pages/MarkAttendance";
import ViewAttendance from "./pages/ViewAttendance";
import IndividualLedger from "./pages/IndividualLedger";
import GuesthousePaymentDetails from "./pages/GuesthousePaymentDetails";
import GuesthouseAdminEditBooking from "./pages/GuesthouseAdminEditBooking";
import GuesthouseInvoiceDetails from "./pages/GuesthouseInvoiceDetails";
import PrintComplaints from "./pages/PrintComplaints";
import SmsLogs from "./pages/SmsLogs";

function App() 
{
	const element = useRoutes([
		{
			path: "/master-module",
			element: (
				<ProtectedRoute>
					<MasterModule />
				</ProtectedRoute>
			),
		},
		{
			path: "/dental-att",
			element: (
				<ProtectedRoute>
					<DentalAtt />
				</ProtectedRoute>
			),
		},
		{
			path: "/admin-att",
			element: (
				<ProtectedRoute>
					<AdminAtt />
				</ProtectedRoute>
			),
		},
		{
			path: "/cdoe-att",
			element: (
				<ProtectedRoute>
					<CdoeAtt />
				</ProtectedRoute>
			),
		},
		{
			path: "/attendance",
			element: (
				<ProtectedRoute>
					<Attendance />
				</ProtectedRoute>
			),
		},
		{ path: "/login", element: <Login /> },
		{ path: "/forgot-password", element: <ForgotPassword /> },
		{ path: "/employee-instructions", element: <EmployeeInstructions /> },
		{ path: "/", element: <PublicDashboard /> },
		{ path: "/employee/new", element: <EmployeeRegister /> },
		{ path: "/college-teacher-registration", element: <CollegeTeacherRegistration /> },
		{ path: "/about-us", element: <AboutUs /> },
		{ path: "/contact-us", element: <ContactUs /> },
		{ path: "/guesthouse/info", element: <GuesthouseContent /> },
		{ path: "/profile", element: <Profile /> },
		{
			path: "/profile/edit",
			element: (
				<ProtectedRoute>
					<EditProfile />
				</ProtectedRoute>
			),
		},
		{
			path: "/logout",
			element: (
				<ProtectedRoute>
					<Logout />
				</ProtectedRoute>
			),
		},
		{
			path: "/infra/departments-centres",
			element: (
				<ProtectedRoute>
					<DepartmentsCentres />
				</ProtectedRoute>
			),
		},
		{
			path: "/directory",
			element: (
				<ProtectedRoute>
					<Directory />
				</ProtectedRoute>
			),
		},
		{
			path: "/holidays",
			element: <HolidayList />
		},
		{
			path: "/switch-role",
			element: (
				<ProtectedRoute>
					<SwitchRole />
				</ProtectedRoute>
			),
		},
		{
			path: "/basic-role",
			element: (
				<ProtectedRoute>
					<BasicRole />
				</ProtectedRoute>
			),
		},
		{
			path: "/change-password",
			element: (
				<ProtectedRoute>
					<ChangePassword />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/pending-bookings",
			element: (
				<ProtectedRoute>
					<GuesthousePendingBookings />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/room-logbook",
			element: (
				<ProtectedRoute>
					<GuesthouseRoomLogbook />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/checkin-checkout",
			element: (
				<ProtectedRoute>
					<GuesthouseCheckInCheckOut />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/tariff",
			element: (
				<ProtectedRoute>
					<GuesthouseTariff />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/rooms",
			element: (
				<ProtectedRoute>
					<Rooms />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/booking-request",
			element: (
				<ProtectedRoute>
					<GuesthouseBooking />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/booking-request-admin",
			element: (
				<ProtectedRoute>
					<GuesthouseBookingRequestAdmin />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/booking-request-by-mobile",
			element: (
				<ProtectedRoute>
					<GuesthouseBookingRequestByMobile />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/change-request",
			element: (
				<ProtectedRoute>
					<GuesthouseChangeRequest />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/booking-status",
			element: (
				<ProtectedRoute>
					<GuesthouseBookingStatus />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/booking-edit/:bookingId",
			element: (
				<ProtectedRoute>
					<GuesthouseBookingEditRequest />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/admin-edit/:bookingId",
			element: (
				<ProtectedRoute>
					<GuesthouseAdminEditBooking />
				</ProtectedRoute>
			),
		},
		{
			path: "/dashboard",
			element: (
				<ProtectedRoute>
					<Dashboard />
				</ProtectedRoute>
			),
		},
		{
			path: "/LeaveDetails",
			element: (
				<ProtectedRoute>
					<LeaveDetails />
				</ProtectedRoute>
			),
		},
		{
			path: "/new-emp-leave",
			element: (
				<ProtectedRoute>
					<NewEmpLeave />
				</ProtectedRoute>
			),
		},
		{
			path: "/leave-status",
			element: (
				<ProtectedRoute>
					<LeaveStatus />
				</ProtectedRoute>
			),
		},
		{
			path: "/employee-edit/:id",
			element: (
				<ProtectedRoute>
					<EmployeeEdit />
				</ProtectedRoute>
			),
		},
		{
			path: "/employee-list",
			element: <EmployeeListMaster />,
		},
		{
			path: "/seniority-list",
			element: (
				<ProtectedRoute>
					<SeniorityList />
				</ProtectedRoute>
			),
		},
		{
			path: "/seniority-list-office",
			element: (
				<ProtectedRoute>
					<SeniorityListOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/members-list",
			element: (
				<ProtectedRoute>
					<DepartmentRecord />
				</ProtectedRoute>
			),
		},
		{
			path: "/fellows-list",
			element: (
				<ProtectedRoute>
					<FellowsList />
				</ProtectedRoute>
			),
		},
		{
			path: "/college-teachers-list",
			element: (
				<ProtectedRoute>
					<CollegeTeachersList />
				</ProtectedRoute>
			),
		},
		{
			path: "/dr-colleges",
			element: (
				<ProtectedRoute>
					<DeputyRegistrarColleges />
				</ProtectedRoute>
			),
		},
		{
			path: "/dr-colleges/college-list",
			element: (
				<ProtectedRoute>
					<DrCollegeList />
				</ProtectedRoute>
			),
		},
		{
			path: "/dr-colleges/pending-principals",
			element: (
				<ProtectedRoute>
					<DrPendingPrincipals />
				</ProtectedRoute>
			),
		},
		{
			path: "/residential-complaints",
			element: (
				<ProtectedRoute>
					<ComplaintStatus />
				</ProtectedRoute>
			),
		},
		{
			path: "/residential-complaints/new",
			element: (
				<ProtectedRoute>
					<NewResidentialComplaint />
				</ProtectedRoute>
			),
		},
		{
			path: "/official-complaints",
			element: (
				<ProtectedRoute>
					<OfficialComplaintStatus />
				</ProtectedRoute>
			),
		},
		{
			path: "/official-complaints/new",
			element: (
				<ProtectedRoute>
					<NewDepartmentComplaint />
				</ProtectedRoute>
			),
		},
		{
			path: "/pending-verifications",
			element: (
				<ProtectedRoute>
					<PendingVerifications />
				</ProtectedRoute>
			),
		},
		{
			path: "/pending-verifications-teachers",
			element: (
				<ProtectedRoute>
					<PendingVerificationsTeachers />
				</ProtectedRoute>
			),
		},
		{
			path: "/pending-verifications-members",
			element: (
				<ProtectedRoute>
					<PendingVerificationsMembers />
				</ProtectedRoute>
			),
		},
		{
			path: "/sanctioned-posts",
			element: (
				<ProtectedRoute>
					<SanctionedPosts />
				</ProtectedRoute>
			),
		},
		{
			path: "/leave-details-office",
			element: (
				<ProtectedRoute>
					<LeaveDetailsOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/pending-leave-office",
			element: (
				<ProtectedRoute>
					<PendingLeaveOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/leave-by-office-new",
			element: (
				<ProtectedRoute>
					<NewLeaveByOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/achievements-office",
			element: (
				<ProtectedRoute>
					<AchievementsOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/achievement-by-office-new",
			element: (
				<ProtectedRoute>
					<NewAchievementOffice />
				</ProtectedRoute>
			),
		},
		{
			path: "/MyAchievements",
			element: (
				<ProtectedRoute>
					<MyAchievements />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-attendance",
			element: (
				<ProtectedRoute>
					<StudentAttendance />
				</ProtectedRoute>
			),
		},
		{
			path: "/students-list",
			element: (
				<ProtectedRoute>
					<StudentsList />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-leave",
			element: (
				<ProtectedRoute>
					<StudentLeave />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-leave-new",
			element: (
				<ProtectedRoute>
					<NewStudentLeave />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-ind-leave",
			element: (
				<ProtectedRoute>
					<StudentIndLeave />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-ind-att",
			element: (
				<ProtectedRoute>
					<StudentIndAtt />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-monthly-att-raw",
			element: (
				<ProtectedRoute>
					<StudentMonthlyAttRaw />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-monthly-att-leave",
			element: (
				<ProtectedRoute>
					<StudentMonthlyAttLeave />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-upload-att",
			element: (
				<ProtectedRoute>
					<StudentUploadAtt />
				</ProtectedRoute>
			),
		},
		{
			path: "/student-verified-list",
			element: (
				<ProtectedRoute>
					<StudentVerifiedList />
				</ProtectedRoute>
			),
		},
		{
			path: "/resolver-complaint-list",
			element: (
				<ProtectedRoute>
					<ResolverComplaintList />
				</ProtectedRoute>
			),
		},
		{
			path: "/resolver-action",
			element: (
				<ProtectedRoute>
					<ResolverAction />
				</ProtectedRoute>
			),
		},
		{
			path: "/resolver-pending",
			element: (
				<ProtectedRoute>
					<ResolverPending />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse-new-member",
			element: (
				<ProtectedRoute>
					<NewMember />
				</ProtectedRoute>
			),
		},
		{
			path: "/shift-employee",
			element: (
				<ProtectedRoute>
					<ShiftEmployee />
				</ProtectedRoute>
			),
		},
		{
			path: "/special-roles",
			element: (
				<ProtectedRoute>
					<SpecialRoles />
				</ProtectedRoute>
			),
		},
		{
			path: "/departmental-roles",
			element: (
				<ProtectedRoute>
					<DepartmentalRoles />
				</ProtectedRoute>
			),
		},
		{
			path: "/mark-attendance",
			element: (
				<ProtectedRoute>
					<MarkAttendance />
				</ProtectedRoute>
			),
		},
		{
			path: "/view-attendance",
			element: (
				<ProtectedRoute>
					<ViewAttendance />
				</ProtectedRoute>
			),
		},
		{
			path: "/individual-ledger",
			element: (
				<ProtectedRoute>
					<IndividualLedger />
				</ProtectedRoute>
			),
		},
		{
			path: "/payment-details",
			element: (
				<ProtectedRoute>
					<GuesthousePaymentDetails />
				</ProtectedRoute>
			),
		},
		{
			path: "/guesthouse/invoice-details",
			element: (
				<ProtectedRoute>
					<GuesthouseInvoiceDetails />
				</ProtectedRoute>
			),
		},
		{
			path: "/print-complaints",
			element: (
				<ProtectedRoute>
					<PrintComplaints />
				</ProtectedRoute>
			),
		},
		{
			path: "/sms-logs",
			element: (
				<ProtectedRoute>
					<SmsLogs />
				</ProtectedRoute>
			),
		},
	]);

  return (
    <Layout>
			{element}
    </Layout>
  );
}
export default App;